<template>
    <div class="rounded-1 shadow-sm sn-header-div">
        <h3><i :class="icona"></i>&nbsp;&nbsp;{{titolo}}</h3>
    </div>
</template>

<script>
export default {
    name: "ContentHeader",
    props: {
        icona: {
            type: String,
            default: "fas fa-tachometer-alt"
        },
        titolo: {
            type: String,
            default: "titolo"
        },
    },

}
</script>

<style scoped>
.sn-header-div {
    width: 98%;
    background-color: #ddd;
    border:solid 1px #ccc;
    padding: 10px 10px 10px 10px;
    color: #333;
    margin-bottom: 15px;

}

.sn-header-div i {
    color: #CC3731;

}
</style>